export default __webpack_public_path__ + "static/media/Subscribers.bcb9d899.svg";